import { StoreAction, XmAction } from 'store/actions';
import { BroadbandLabels } from './models';

export function BroadbandLabelReducer(state: BroadbandLabels, action: XmAction<BroadbandLabels>): BroadbandLabels {
    switch (action.type) {
        case StoreAction.GET_BROADBAND_LABELS:
            return action.payload;
        default:
            return state;
    }
}
